// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import auth from './auth'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClock } from '@fortawesome/free-regular-svg-icons'
import { faEdit, faPlus, faUser, faIdCard, faAt, faCar, faKey, faEye, faCalendarAlt, faSpinner, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueToastr from '@deveodk/vue-toastr'
import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import api from '@/api/api'

library.add(faClock, faEdit, faPlus, faUser, faIdCard, faAt, faCar, faKey, faEye, faCalendarAlt, faSpinner, faTrashAlt, faCheck)

Vue.component('v-select', vSelect)
Vue.component('fa-icon', FontAwesomeIcon)
Vue.component('multiselect', Multiselect)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueToastr, {defaultPosition: 'toast-top-right'})
Vue.use(VueMoment)
Vue.prototype.$auth = auth

api.setBaseURL(`${location.protocol}${process.env.API_URL}`) // use http or https depending on how the frontend is being hosted
localStorage.token && api.setAuthHeader(localStorage.token)
api.init()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js